/* eslint-disable import/prefer-default-export */

import { buildQuery } from '../helpers';
import { HOME_GET_LESSONS, HOME_GET_LESSONS_SUCCESS, HOME_GET_LESSONS_FAIL, HOME_RESET_LESSONS } from '../constants';
export function getLessons(params) {
  var doNotAppend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var query = buildQuery(params);
  return {
    types: [HOME_GET_LESSONS, HOME_GET_LESSONS_SUCCESS, HOME_GET_LESSONS_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/lessons?".concat(query), {
        method: 'GET'
      });
    },
    doNotAppend: doNotAppend
  };
}
export function resetLessons() {
  return {
    type: HOME_RESET_LESSONS
  };
}